import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DataTableComponent } from '../../../shared/components/data-table/data-table.component';
import { IRewardShip } from '../../models/rewardShip.interface';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'upsc-rewardship-table',
  templateUrl: './rewardship-table.component.html',
  styleUrls: ['./rewardship-table.component.scss'],
})
export class RewardshipTableComponent extends DataTableComponent<IRewardShip> implements OnInit {
  @Output() pageChanged: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  public totalItems = 0;

  public ngOnInit() {
    super.ngOnInit();
    this.displayedColumns = ['InvoiceID', 'ActivityDate', 'DueDate', 'PaidDate', 'PotentialPoints', 'AvailablePoints', 'RedeemedPoints', 'ForfeitedPoints'];
    this.totalItems = this.items && this.items.length ? this.items.length : 0;
  }

  public onPageChanged(pageEvent: PageEvent) {
    this.pageChanged.emit(pageEvent);
  }

}
